// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { AppendToBodyModule } from 'NewAngular/features/directives/append-to-body/append-to-body.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SimpleDropdownModule {
}
SimpleDropdownModule.ɵfac = function SimpleDropdownModule_Factory(t) { return new (t || SimpleDropdownModule)(); };
SimpleDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SimpleDropdownModule });
SimpleDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AppendToBodyModule,
        CommonModule,
        DisabledModule,
        FormsModule,
        HelpModalModule,
        IconModule,
        TooltipModule] });
